import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Homepage from "./pages/HomePage";
import LandingPageV2 from "./pages/LandingPageV2";
import CoachingPage from "./pages/CoachingPage";
import EventsPage from "./pages/EventsPage";
import ServicesPage from "./pages/ServicesPage";
import ResultPage from "./pages/ResultPage";
import AdminPage from "./pages/AdminPage";
import ErrorPage from "./pages/ErrorPage";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<LandingPageV2 />} />
          <Route path="/v1" element={<Homepage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/coaching" element={<CoachingPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/results" element={<ResultPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
